export interface ITimeSpan {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    miliseconds: number;
    totalDays: number;
    totalHours: number;
    totalMinutes: number;
    totalSeconds: number;
    totalMiliseconds: number;
}

export function getInterval(from: Date, to: Date): ITimeSpan {
    const totalMiliseconds = to.valueOf() - from.valueOf();
    const totalSeconds = Math.floor(totalMiliseconds / 1000);
    const totalMinutes = Math.floor(totalMiliseconds / 60000);
    const totalHours = Math.floor(totalMiliseconds / 3600000);
    const totalDays = Math.floor(totalMiliseconds / 86400000);
    const days = totalDays;
    const hours = Math.floor((totalMiliseconds - days * 86400000) / 3600000);
    const minutes = Math.floor((totalMiliseconds - (days * 86400000 + hours * 3600000)) / 60000);
    const seconds = Math.floor((totalMiliseconds - (days * 86400000 + hours * 3600000 + minutes * 60000)) / 1000);
    const miliseconds = totalMiliseconds - (days * 86400000 + hours * 3600000 + minutes * 60000 + seconds * 1000);
    return {
        totalMiliseconds: totalMiliseconds,
        totalSeconds: totalSeconds,
        totalMinutes: totalMinutes,
        totalHours: totalHours,
        totalDays: totalDays,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        miliseconds: miliseconds
    };
}

export function getDateTimeWithOffset(date: Date): string {
    return getDateTime(date) + getOffset(date);
}

function getDateTime(date: Date): string {
    const dt = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const mins = date.getMinutes();
    const secs = date.getSeconds();

    // String such as 2016-07-16T19:20:30
    return (
        year +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (dt < 10 ? '0' + dt : dt) +
        'T' +
        (hours < 10 ? '0' + hours : hours) +
        ':' +
        (mins < 10 ? '0' + mins : mins) +
        ':' +
        (secs < 10 ? '0' + secs : secs)
    );
}

function getOffset(date: Date): string {
    const timezone_offset_min = date.getTimezoneOffset();
    const offset_hrs = Math.abs(timezone_offset_min / 60);
    const offset_mins = Math.abs(timezone_offset_min % 60);
    let timezone_standard: string = '';

    const offsetString = (offset_hrs < 10 ? '0' + offset_hrs : offset_hrs) + ':' + (offset_mins < 10 ? '0' + offset_mins : offset_mins);

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (timezone_offset_min < 0) {
        timezone_standard = '+' + offsetString;
    } else if (timezone_offset_min > 0) {
        timezone_standard = '-' + offsetString;
    } else if (timezone_offset_min == 0) timezone_standard = 'Z';

    return timezone_standard;
}

export function getLastDayOfMonth(year: number, month: number): Date {
    return new Date(year, month + 1, 0);
}

export function addDays(date: Date, units: number) {
    return addDate(date, 'day', units);
}

export function addHours(date: Date, units: number) {
    return addDate(date, 'hour', units);
}
export function addDate(date: Date, interval: 'year' | 'quarter' | 'month' | 'hour' | 'minute' | 'second' | 'day' | 'week', units: number) {
    let newDate = new Date(date.getTime());
    switch (interval.toLowerCase()) {
        case 'year':
            newDate.setFullYear(newDate.getFullYear() + units);
            break;
        case 'quarter':
            newDate.setMonth(newDate.getMonth() + 3 * units);
            break;
        case 'month':
            newDate.setMonth(newDate.getMonth() + units);
            break;
        case 'week':
            newDate.setDate(newDate.getDate() + 7 * units);
            break;
        case 'day':
            newDate.setDate(newDate.getDate() + units);
            break;
        case 'hour':
            newDate.setTime(newDate.getTime() + units * 3600000);
            break;
        case 'minute':
            newDate.setTime(newDate.getTime() + units * 60000);
            break;
        case 'second':
            newDate.setTime(newDate.getTime() + units * 1000);
            break;
        default:
            newDate = undefined;
            break;
    }
    return newDate;
}

export function addDateSetTo6HoursMorning(date: Date, interval: 'year' | 'quarter' | 'day' | 'week', units: number) {
    var newDate = addDate(date, interval, units);
    newDate.setHours(6, 0, 0, 0);
    return newDate;
}

export function areDatesEqual(date1?: Date, date2?: Date) {
    return date1 === date2 || (date1 && date2 && date1.getTime() === date2.getTime());
}

export function isTheSameDay(date1: Date, date2: Date) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
}

export function isTheSameYear(date1: Date, date2: Date) {
    return date1.getFullYear() === date2.getFullYear();
}

export const secondsToMinutesForMatchTime = (seconds: number): number => {
    return Math.ceil((seconds) / 60);
};

export const getNextWeekendStartTime = (date: Date = new Date()): Date => {
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
        return date;
    }
    else {
        const diff = 6 - dayOfWeek;
        let newDate = addDate(date, 'day', diff); //Saturday
        newDate.setHours(0, 0, 0, 0);
        return newDate;
    }
}

export const getNextWeekendEndTime = (date: Date = new Date()): Date => {
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 0) {
        let newDate = addDate(date, 'day', 1); //Monday
        newDate.setHours(6, 0, 0, 0);
        return newDate;
    }
    else {
        const diff = 6 - dayOfWeek;
        let newDate = addDate(date, 'day', diff + 2); //Monday
        newDate.setHours(6, 0, 0, 0);
        return newDate;
    }
}
